const credentials = {
  userApp: {
    clientId: "fbe23c14-2f12-42d8-bd7b-dadace04fe4a",
    apiKey: "6a13352c-f388-4731-9957-e8b5a81d564d",
    rolName: "FEPU",
  },
};

export default credentials;